// extracted by mini-css-extract-plugin
export default {"containerBtn":"styles-scoped__containerBtn--a08Mr","btn":"styles-scoped__btn--cB4T2"};